<template>
  <BannerComponent />
  <CourseCardsComponent :data="data" />
  <!-- <ProgressTriangleComponent /> -->
  <PhasesComponent />
  <!-- <TriangleComponent /> -->
  <!-- <AboutComponent /> -->
   <HomeLastCoursesComponent :display_count="6" />
  <SpecialStudentsComponent />
  <ToTopComponent />
</template>

<script>
// @ is an alias to /src
import {
  BannerComponent,
  SpecialStudentsComponent,
  CourseCardsComponent,
  // AboutComponent,
  PhasesComponent,
  ToTopComponent,
} from "@/components";
import HomeLastCoursesComponent from "@/components/HomeLastCourses/HomeLastCoursesComponent.vue";
// import ProgressTriangleComponent from "@/components/ProgressTriangle/ProgressTriangleComponent.vue";
// import TriangleComponent from "@/components/Triangle/TriangleComponent.vue";
import config from "@/services/config";
import axios from "axios";

export default {
  name: "HomeView",
  components: {
    BannerComponent,
    SpecialStudentsComponent,
    CourseCardsComponent,
    // ProgressTriangleComponent,
    HomeLastCoursesComponent,
    // AboutComponent,
    PhasesComponent,                         
    ToTopComponent,
    // TriangleComponent
  },
  data() {
    return {
      data: [],
    };
  },
  created() {
    axios
      .get(`${config.basURL}course/course-list`, {
        headers: {
          auth: this.$store.state.userToken,
        },
      })
      .then((res) => {
        this.data = res.data;
      })
      .catch((err) => {
        console.log(err.message);
      });
  },
};
</script>
<style scoped></style>
